module.exports = __webpack_public_path__ + "static/media/tyrion.13501cb6.jpg";